import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "copy" }
const _hoisted_3 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 0,
  viewBox: "0 0 24 24"
}
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 24 24"
}
const _hoisted_6 = {
  key: 2,
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    class: "studio",
    "aria-label": _ctx.t('homeStudioTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeStudioTitle')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.t('homeStudioText')), 1)
    ]),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tools, (tool) => {
        return (_openBlock(), _createElementBlock("li", {
          key: tool.titleKey,
          style: _normalizeStyle({ '--accent': tool.accent })
        }, [
          _createElementVNode("span", _hoisted_3, [
            (tool.icon === 'analysis')
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "8.5",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.6"
                  }, null, -1),
                  _createElementVNode("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3",
                    fill: "currentColor"
                  }, null, -1)
                ]))]))
              : (tool.icon === 'wardrobe')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("rect", {
                      x: "4",
                      y: "4",
                      width: "7",
                      height: "7",
                      rx: "1.6",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.6"
                    }, null, -1),
                    _createElementVNode("rect", {
                      x: "13",
                      y: "4",
                      width: "7",
                      height: "7",
                      rx: "1.6",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.6"
                    }, null, -1),
                    _createElementVNode("rect", {
                      x: "4",
                      y: "13",
                      width: "7",
                      height: "7",
                      rx: "1.6",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.6"
                    }, null, -1),
                    _createElementVNode("rect", {
                      x: "13",
                      y: "13",
                      width: "7",
                      height: "7",
                      rx: "1.6",
                      fill: "currentColor"
                    }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("path", {
                      d: "M12 3c2.8 4.2 6.5 8.2 6.5 11.2A6.5 6.5 0 0 1 12 21a6.5 6.5 0 0 1-6.5-6.8C5.5 11.2 9.2 7.2 12 3Z",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "1.6",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ]))]))
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.t(tool.titleKey)), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.t(tool.bodyKey)), 1)
        ], 4))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}